module.exports = __webpack_public_path__ + "static/media/land-of-dreams.1dd42b69.jpg";